import { forwardRef, type LabelHTMLAttributes } from 'react';

import { cn } from '../../../utils';

interface MultiselectLabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  children: React.ReactNode;
}

export const MultiselectLabel = forwardRef<
  HTMLLabelElement,
  MultiselectLabelProps
>(({ className, children, ...props }, ref) => {
  return (
    <label
      ref={ref}
      className={cn('text-sm font-medium', className)}
      {...props}
    >
      {children}
    </label>
  );
});

MultiselectLabel.displayName = 'MultiselectLabel';
